import { get } from "./base-api";

// company profie
export const getCompanyProfile = () => {
  return get('/company-profile');
};
